import { z } from "zod/v4";
/** string型の "true","false"も扱えるようにするスキーマ */
const BooleanString = z
    .enum(["true", "false"])
    .transform((val) => val === "true");
const StringifyBooleanSchema = z.boolean().or(BooleanString).pipe(z.boolean());
export const StringifyBoolean = {
    schema: StringifyBooleanSchema,
};
//# sourceMappingURL=stringify-boolean.js.map